import React, {useMemo, useState} from "react";
import styles from "./styles.scss";
import IconComponent from "../../../../components/commons/IconComponent";
import NumberInput from "./components/NumberInput";
import UnitSelector from "./components/UnitSelector";
import {connect} from "react-redux";
import {getTranslation} from "../../../../store/getters";
import {sizeUnits} from "../../../../utils/pageSize";

function MagazineCustomSizeModal({translation, onClose, onSubmit}) {
    const [unit, setUnit] = useState("px");
    const [width, setWidth] = useState(0);
    const [height, setHeight] = useState(0);

    const onClickSubmit = () => onSubmit({unit, width, height});

    const [isWidthInvalid, isHeightInvalid] = useMemo(() => {
        const sizeUnit = sizeUnits[unit] || 1;
        return [
            width * sizeUnit > MAX_SIZE,
            height * sizeUnit > MAX_SIZE,
        ];
    }, [unit, width, height]);

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <div className={styles.title}>{translation("custom-size-modal-title")}</div>
                <div className={styles.close} onClick={onClose}>
                    <IconComponent icon="close-modal-custom-size"/>
                </div>
            </div>
            <div className={styles.content}>
                <div className={styles.field}>
                    <div className={styles.label}>{translation("custom-size-modal-label-width")}</div>
                    <NumberInput value={width} onChange={setWidth} unit={unit}
                                 invalid={isWidthInvalid}/>
                </div>
                <div className={styles.field}>
                    <div className={styles.label}>{translation("custom-size-modal-label-height")}</div>
                    <NumberInput value={height} onChange={setHeight} unit={unit}
                                 invalid={isHeightInvalid}/>
                </div>
                <div className={styles.field}>
                    <div className={styles.label}>&nbsp;</div>
                    <UnitSelector value={unit} onChange={setUnit}/>
                </div>
            </div>
            <div className={styles.footer}>
                <button className={styles.button}
                        disabled={!width || isWidthInvalid || !height || isHeightInvalid}
                        onClick={onClickSubmit}>
                    {translation("custom-size-modal-button")}
                </button>
            </div>
        </div>
    );
}

const MAX_SIZE = 2160;

export default connect(state => ({
    translation: getTranslation(state),
}))(MagazineCustomSizeModal);


// WEBPACK FOOTER //
// ./src/pages/Dashboard/components/MagazineCustomSizeModal/index.js